module.exports = __webpack_public_path__ + "img/左右翻转-角标2.8d24cb7d.svg";